const InputValidator = {


	/**
	 * Checks if provided value is an email address
	 * 
	 * @param 	{string}
	 * @return 	{bool}
	 */
	isValidEmail( value ) {
		const regex = /^\S+@\S+$/

		return regex.test( value )
	},


	/**
	 * Checks if provided value is a valid password, based on:
	 * 	- is at least 10 characters long
	 *  - contains at least 1 number
	 *  - contains at least 1 special character
	 * 
	 * @param 	{string}
	 * @return 	{obj}
	 */
	isValidPassword( value ) {
		value = value.trim()

		return {
			hasNumber: 	this.checkForNumber( value ),
			hasSymbol: 	this.checkForSpecialCharacter( value ),
			length: 	( 10 <= value.length ),
		}
	},


	/**
	 * Checks that string has at least one special character
	 * 
	 * @param	{string}
	 * @return	{bool}
	 */
	checkForSpecialCharacter( value ) {
		return /(?=.*[!\?<>.,/@#$%^&*])/.test( value )
	},


	/**
	 * Checks that string has at least one number
	 * 
	 * @param	{string}
	 * @return	{bool}
	 */
	checkForNumber( value ) {
		return /\d/.test( value )
	},


}


export default InputValidator
